var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Loading'):_vm._e(),(_vm.docHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.docHtml)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }